import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FilterAttributeOptionComponentDef } from '@df/catalog-ui/listing/filter/filter-attribute-option.component.def';
import { Model } from '@df/catalog/model';
import { GridColumnDirective } from '@df/ui/atomic/atom/grid/grid-column.directive';
import { GridDirective } from '@df/ui/atomic/atom/grid/grid.directive';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleClassDirective } from '@df/ui/toggle/toggle-class.directive';
import { BehaviorSubject } from 'rxjs';

@Component({
    standalone: true,
    selector: 'samples-filter',
    templateUrl: './samples-filter.html',
    imports: [ToggleClassDirective, HideUpComponent, GridDirective, GridColumnDirective],
    styleUrl: './samples-filter.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SamplesFilterComponent<T extends Model> extends FilterAttributeOptionComponentDef<T> implements OnInit {
    openState = new BehaviorSubject<boolean>(false);

    override ngOnInit(): void {
        super.ngOnInit();
        this.openState.subscribe(() => this.detectChanges());
    }

    protected get title(): string {
        const attr = this.filter.attribute;
        switch (attr.data?.code) {
            case 'fabric_style':
                return 'Fabric Group';
            case 'fabric_color':
                return 'Fabric Colour';
            default:
                return attr.data?.label || '';
        }
    }

    protected toggle(): void {
        this.openState.next(!this.openState.value);
    }

    protected get dropdownTitle(): string {
        const attr = this.filter.attribute;
        switch (attr.data?.code) {
            case 'fabric_style':
                return 'All groups';
            case 'fabric_color':
                return 'All colours';
            default:
                return 'All ' + (attr.data?.label ? `${attr.data.label.toLowerCase()}s` : '');
        }
    }
}
